import PropTypes from 'prop-types';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import './FormularioPadrao.css';

// Enum para tamanhos do formulário
export const TAMANHO_FORMULARIO = {
  PADRAO: 'padrao',
  REDUZIDO: 'reduzido'
};

const FormularioPadrao = ({
  children,
  onSalvar,
  onCancelar,
  titulo,
  subtitulo,
  inferiorChildren,
  tituloInterno,
  subtituloInterno,
  componenteDireitaTitulo,
  iconeBotao,
  dataCriacao,
  dataAlteracao,
  tamanho = TAMANHO_FORMULARIO.PADRAO,
  txtBtnSalvar = "Finalizar Cadastro"
}) => {

  // Função para formatar a data
  const formatarData = (dataString) => {
    if (!dataString) return '';
    const data = new Date(dataString);
    return `${data.getDate().toString().padStart(2, '0')}/${(data.getMonth() + 1).toString().padStart(2, '0')}/${data.getFullYear()}`;
  };

  return (
    <div className={`formulario-padrao-container ${tamanho === TAMANHO_FORMULARIO.REDUZIDO ? 'reduzido' : ''}`}>
      {(titulo || subtitulo) && (
        <div className="informacoes-superiores">
          <div>
            {titulo && <h2 className="formulario-padrao-titulo">{titulo}</h2>}
            {subtitulo && <h3 className="formulario-padrao-subtitulo">{subtitulo}</h3>}
          </div>

          {(dataCriacao || dataAlteracao) && (
            <div className="formulario-padrao-datas">
              {dataCriacao && (
                <p className="formulario-padrao-data-info">Criado em {formatarData(dataCriacao)}</p>
              )}
              {dataAlteracao && (
                <p className="formulario-padrao-data-info">
                  Editado em {formatarData(dataAlteracao)}
                </p>
              )}
            </div>
          )}
        </div>
      )}
      <div className="formulario-padrao-box">
        {tituloInterno && (
          <div className="formulario-interno-cabecalho">
            <div className="titulo-interno-container">
              <h2 className="titulo-formulario-interno">{tituloInterno}</h2>

             
              {componenteDireitaTitulo && (
                <div className="componente-direita-titulo">
                  {componenteDireitaTitulo}
                </div>
              )}
            </div>
             {subtituloInterno && (
                <h2 className="subtitulo-formulario-interno" >{subtituloInterno}</h2>
              )}

            <hr className="divisor-titulo-formulario-interno" />
          </div>
        )}

        <div className="formulario-padrao-content">{children}</div>
      </div>

      <div className="formulario-padrao-content-inferior">{inferiorChildren}</div>

      {onSalvar && onCancelar && (
        <div className="formulario-padrao-botoes">
          <BotaoPadrao aoClicar={onCancelar} cancelar={true} texto={'Cancelar'} />
          <BotaoPadrao
            aoClicar={onSalvar}
            texto={txtBtnSalvar}
            confirmar={true}
            icone={iconeBotao}
          />
        </div>
      )}
    </div>
  );
};

FormularioPadrao.propTypes = {
  titulo: PropTypes.string,
  subtitulo: PropTypes.string,
  tituloInterno: PropTypes.string,
  children: PropTypes.node,
  onSalvar: PropTypes.func,
  onCancelar: PropTypes.func,
  iconeBotao: PropTypes.node,
  inferiorChildren: PropTypes.node,
  componenteDireitaTitulo: PropTypes.node,
  dataCriacao: PropTypes.string,
  dataAlteracao: PropTypes.string,
  tamanho: PropTypes.oneOf(Object.values(TAMANHO_FORMULARIO))
};

export default FormularioPadrao;